/** Human labels for fault-analysis enum-ish string fields. Centralises the
 *  rendering so a raw code (e.g. `max_3ph_slg`) never leaks to the UI via a
 *  CSS `capitalize` that only touches the first letter. */

const FAULT_CURRENT_TYPE_LABELS: Record<string, string> = {
  max_3ph_slg: 'Max(3φ, SLG)', // 3φ = "3φ"; the fuse duty basis (spec §5 item 5)
  asymmetrical_rms: 'Asym. RMS',
  symmetrical: 'Symmetrical',
}

/** De-underscore + sentence-case an unknown code as a safe fallback. */
function humanise(code: string): string {
  const s = code.replace(/_/g, ' ').trim()
  return s.length === 0 ? s : s[0].toUpperCase() + s.slice(1)
}

export function faultCurrentTypeLabel(code: string): string {
  return FAULT_CURRENT_TYPE_LABELS[code] ?? humanise(code)
}

const CLEARING_SOURCE_LABELS: Record<string, string> = {
  tcc: 'TCC curve', // Phase 3: clearing time read from the seeded total-clear curve
}

export function clearingSourceLabel(code: string): string {
  return CLEARING_SOURCE_LABELS[code] ?? humanise(code)
}

/** True when an arc-flash clearing time was NOT read from real device data.
 *  The service emits 'device' | 'tcc' (real) and 'default' | 'unknown'
 *  (estimated) — this mirrors its estimated_clearing_time_count predicate
 *  (services/fault_analysis.py: `clearing_source in ("default", "unknown")`).
 *  A1: rows with an estimated clearing time grey their energy/PPE cells. */
export function isEstimatedClearing(source: string | null | undefined): boolean {
  return source === 'default' || source === 'unknown'
}
